module.exports = __webpack_public_path__ + "media/shortSomeCoin.8615ac99.mp3";